import script from "./ExamArtifactWorkspace.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamArtifactWorkspace.vue?vue&type=script&setup=true&lang=ts"

import "./ExamArtifactWorkspace.vue?vue&type=style&index=0&id=051355ec&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051355ec"]])

export default __exports__